import { Tab as TabBase, Tabs as TabsBase } from '@mui/material';

import { styled } from '../styles/styles';

export const Tab = styled(TabBase)(({ theme }) => ({
  position: 'relative',
  color: theme.palette.text.secondary,
  transition: 'color 0.5s ease',

  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },

  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: -50,
    width: '150%',
    height: '2px',
    backgroundColor: 'transparent',
    transition: 'background-color 0.5s ease',
  },

  '&.Mui-selected::after': {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const Tabs = styled(TabsBase)({});

Tabs.defaultProps = {
  TabIndicatorProps: { style: { display: 'none' } },
};
